import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const createCustomQuote = (payload) => api.post("/custom-quotes", payload).then((r) => r.data);
export const createCheckout = (payload) => api.post("/checkout/create", payload).then((r) => r.data);
export const getHealth = () => api.get("/health").then((r) => r.data);
